import React from 'react';
import { HelpText } from './HelpText';
import classNames from 'classnames';
const FormGroupLabel = ({ children, label, valid, id, className, isShowRequired, feedback, feedbackClassName, helpText, }) => {
    const getValidClassName = (newValid) => {
        if (newValid === true) {
            return 'valid';
        }
        else if (newValid === false) {
            return 'invalid';
        }
        else {
            return '';
        }
    };
    const renderFeedback = () => {
        if (feedback) {
            return React.createElement("div", { className: classNames('ac-feedback', getValidClassName(valid), feedbackClassName) }, feedback);
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    const renderHelpText = () => {
        return helpText ? React.createElement(HelpText, null, helpText) : React.createElement(React.Fragment, null);
    };
    const renderLabel = () => {
        if (label) {
            return (React.createElement("label", { htmlFor: id, className: 'ac-label d-flex align-items-center' },
                label,
                React.createElement("span", { className: 'ml-x1' }, isShowRequired ? '*' : '')));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    const css = classNames('ac-form-group', 'ac-input', getValidClassName(valid), className);
    return (React.createElement("div", { className: css },
        renderLabel(),
        children,
        renderFeedback(),
        renderHelpText()));
};
export { FormGroupLabel };
//# sourceMappingURL=FormGroupLabel.js.map